export const SOLUTIONS = [
  {
    id: "business",
    title: "Evontra Business",
    tagline: "Conferences, meets & corporate gatherings",
    items: ["Conferences & Summits", "Leadership Meets", "Dealer & Partner Meets", "Sales Gatherings", "Annual Celebrations", "Awards & Recognition", "Gala Experiences", "Corporate Meetings"],
  },
  {
    id: "impact",
    title: "Evontra Impact",
    tagline: "Launches, activations & brand campaigns",
    items: ["Product Launches", "Brand Activations", "Exhibitions", "Experiential Campaigns", "Product Engagement", "Promotional Experiences", "BTL Campaigns", "Roadshows"],
  },
  {
    id: "people",
    title: "Evontra People",
    tagline: "Engagement, offsites & team experiences",
    items: ["Employee Engagement", "Team Experiences", "Corporate Offsites", "Family Experiences", "Outdoor Activities", "Adventure Experiences", "Employee Meets", "Corporate Outings"],
  },
  {
    id: "live",
    title: "Evontra Live",
    tagline: "Concerts, productions & entertainment",
    items: ["Live Concerts", "Music Experiences", "Stage Productions", "Dance Experiences", "Comedy Shows", "Cultural & Food Festivals", "Artist Experiences", "Celebrity Appearances"],
  },
  {
    id: "play",
    title: "Evontra Play",
    tagline: "Sports, tournaments & institutional events",
    items: ["Sports Events", "Corporate Sports Days", "Cricket Events", "Tournaments", "Team Competitions", "Institutional Events", "Government Events", "Special Events"],
  },
  {
    id: "connect",
    title: "Evontra Connect",
    tagline: "Hybrid, virtual & event technology",
    items: ["Hybrid Experiences", "Virtual Experiences", "Digital Registration", "Event Apps", "QR Check-In", "Live Streaming", "Audience Engagement", "Event Analytics", "Interactive Experiences", "Technology Events", "Training Experiences"],
  },
];

export const SERVICES = [
  "Event Strategy & Planning", "Creative & Concept Development", "Event Production", "AV & Technology", "Venue Management", "Event Branding", "Guest Management", "Hospitality & Logistics", "Entertainment Management", "Event Registration", "On-Ground Execution",
];

export const EXPLORE = [
  {
    title: "Venues",
    items: ["Conference Venues", "Hotels & Resorts", "Convention Centres", "Outdoor Venues", "Unique Venues"],
  },
  {
    title: "Artists & Entertainment",
    items: ["Singers & Musicians", "Bands", "DJs", "Performers", "Comedians", "Hosts & Anchors", "Celebrity Artists"],
  },
  {
    title: "Event Partners",
    items: ["AV & Production", "Décor & Fabrication", "Catering", "Photography & Videography", "Event Staffing", "Transportation", "Event Technology"],
  },
  {
    title: "Destinations",
    items: ["Kolkata", "Delhi NCR", "Mumbai", "Bengaluru", "Hyderabad", "Goa", "Other Destinations"],
  },
];

export const EXPERIENCES = [
  "Corporate Experiences", "Brand Experiences", "Employee Experiences", "Live Experiences", "Sports Experiences", "Technology Experiences", "Conferences", "Product Launches", "Offsites", "Celebrations",
];

export const ABOUT = ["About Evontra", "Our Approach", "Why Evontra", "Our Capabilities"];
